import React from "react";
import styles from "./Rating.css";
import { Modal } from "../Modal";
import classNames from "classnames";
import { Loading } from "../Loading";

export enum ThumbsEnum {
  UP = "UP",
  DOWN = "DOWN"
}

interface RatingProps {
  fleetName: string;
  onSubmit: (thumbs: ThumbsEnum, comment: string | null) => void;
  onClose: () => void;
}

interface RatingState {
  clickedThumbs: ThumbsEnum | null;
  comment: string;
  isLoading: boolean;
}

export class Rating extends React.Component<RatingProps, RatingState> {
  constructor(props: RatingProps) {
    super(props);

    this.state = {
      clickedThumbs: null,
      comment: "",
      isLoading: false
    };
  }

  handleCommentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    this.setState({ comment: value });
  };

  handleRatingClick = (thumbs: ThumbsEnum) => {
    this.setState(prevState => ({
      clickedThumbs: prevState.clickedThumbs === thumbs ? null : thumbs
    }));
  };

  handleSubmit = () => {
    this.setState({ isLoading: true }, () => {
      if (this.state.clickedThumbs) {
        this.props.onSubmit(this.state.clickedThumbs, this.state.comment);
      }
    });
  };

  componentDidMount = () => {
    document.body.style.overflow = "hidden";
  };

  componentWillUnmount = () => {
    // @ts-ignore
    document.body.style.overflow = null;
  };

  render() {
    const { fleetName, onClose } = this.props;
    const { clickedThumbs, comment, isLoading } = this.state;
    const thumbsUpClasses = [
      clickedThumbs === ThumbsEnum.UP ? styles.thumbsUpClicked : ""
    ];
    const thumbsUpCircleClasses = [
      styles.ratingCircle,
      clickedThumbs === ThumbsEnum.UP ? styles.ratingCircleGreen : ""
    ];
    const thumbsDownCircleClasses = [
      styles.ratingCircle,
      clickedThumbs === ThumbsEnum.DOWN ? styles.ratingCircleRed : ""
    ];
    return (
      <Modal onClose={onClose}>
        <div className={styles.ratingModalContainer}>
          <div className={styles.titleWrapper}>
            Avalie o serviço de {fleetName}
          </div>
          <div className={styles.subtitleWrapper}>
            Como você avaliaria o serviço ou entrega?
          </div>
          <div className={styles.ratingButtonsContainer}>
            <div
              className={classNames(thumbsUpCircleClasses)}
              onClick={() => this.handleRatingClick(ThumbsEnum.UP)}
            >
              <span className={classNames(thumbsUpClasses)}>👍</span>
            </div>
            <div
              className={classNames(thumbsDownCircleClasses)}
              onClick={() => this.handleRatingClick(ThumbsEnum.DOWN)}
            >
              <span className={styles.thumbsDown}>👎</span>
            </div>
          </div>
          <div className={styles.ratingCommentWrapper}>
            <textarea
              className={styles.ratingCommentTextArea}
              value={comment}
              onChange={this.handleCommentChange}
              placeholder="Conte mais sobre sua experiência (opcional)"
            />
          </div>
        </div>
        <div className={styles.confirmButtonWrapper}>
          <button
            className={styles.confirmButton}
            onClick={this.handleSubmit}
            disabled={clickedThumbs === null || isLoading}
          >
            {isLoading ? <Loading fill="#ffffff" /> : "Enviar"}
          </button>
        </div>
      </Modal>
    );
  }
}
